import axiosPost from '../axiosPost';

export const estadosDeRegistroDel = async (arg) => {
    const { id } = arg;

    const body = {
        "service": "EstadoDeRegistroDel",
        "params": { "estadoDeRegistroId": id }
    };

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
}